<template>
    <div class="search-list-headline">
        <div class="search-list-headline__header">
            <h1 v-html="mainPackageHeadline.title"></h1>
            <HideFilters v-on:toggleFilters="toggleShowMoreFilters" :filtersHidden="!showMoreFilters"/>
        </div>
        <p class="search-list-headline__description" v-html="mainPackageHeadline.description"></p>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import HideFilters from 'components/user/shared/HideFilters.vue'

    export default {
        name: 'SearchListHeadline',
        components: { HideFilters },
        computed: {
            ...mapGetters({
                mainPackage: 'Search/selectedMainPackage',
                categories: 'Menu/getCategories',
                showMoreFilters: 'CourseFilter/getShowMoreFilterState'
            }),
            mainPackageHeadline () {
                let title = this.$t('General.list_view_title')
                let description = this.$t('General.list_view_description')

                if (this.mainPackage !== undefined && this.categories.length > 0) {
                    const category = this.categories.find(el => el.code === this.mainPackage)
                    title = category?.translatedName
                    if (category.customerSpecific) {
                        description = category?.descriptionOnCollectionList
                    }
                }

                return { title, description }
            },
            isLandingPage () {
                return (this.$route.name === 'home') || (this.$route.name === 'home-courses')
            }
        },
        methods: {
            toggleShowMoreFilters () {
                this.$store.dispatch('CourseFilter/showMoreFilters', !this.showMoreFilters)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .search-list-headline {
        background: $white;
        position: relative;
        z-index: 1;
        margin-top: -30px;
        padding-top: 30px;

        &__header {
            display: flex;
            gap: 20px;
            flex-wrap: wrap;
            margin: 0 0 30px;

            h1 {
                word-break: break-all;
            }
        }

        &__description {
            margin: 0 0 30px;
            font-size: 20px;
            line-height: 3rem;
        }
    }
</style>
